import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent } from '../../shared/icon/icon.component';
import { VehicleService } from '../../services/vehicle.service';

@Component({
  selector: 'app-bottom-nav',
  imports: [RouterLink, RouterLinkActive, IconComponent],
  templateUrl: './bottom-nav.component.html',
  styleUrl: './bottom-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BottomNavComponent {
  public readonly vehicleService = inject(VehicleService);

  public readonly navItems = [
    { label: 'Home', icon: 'home', route: '/dashboard' },
    { label: 'Bieden', icon: 'gavel', route: '/bieden' },
    { label: 'Favorieten', icon: 'heart', route: '/favorieten', showBadge: true },
    { label: 'Gekocht', icon: 'car', route: '/mijn-voertuigen' },
    { label: 'Stats', icon: 'chart', route: '/statistieken' },
  ];
}
